module.exports = __webpack_public_path__ + "img/赵文杰.b06c542b.jpg";